export const FIND_PSEUDONYMS_FAILURE = 'FIND_PSEUDONYMS_FAILURE';

export const findPseudonymsFailure = ({ error, request }) => ({
    type: FIND_PSEUDONYMS_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});